import React from 'react'

import { actionsColumn, conditionNameColumn, } from "Pages/ReportsAlerts/Alerts/Conditions/@components"
import AlertsBaseTable from "Pages/ReportsAlerts/Alerts/@components/Table"
import {
	providersAvailabilityColumn,
	providersNotAvailabilityColumn,
	sitesAvailabilityColumn,
	sitesNotAvailabilityColumn
} from "Pages/ReportsAlerts/Alerts/Conditions/NoAvailability/Table/columns"


export default function NoAvailabilityTable({ data, isLoading, onDeleteAlert, onEditAlert }) {

	return <AlertsBaseTable
		isNoAvailability
		title="Alerts: Not Available"
		data={data}
		isLoading={isLoading}
		columns={[
			conditionNameColumn(),
			...sitesNotAvailabilityColumn(),
			providersNotAvailabilityColumn(),
			...sitesAvailabilityColumn(),
			providersAvailabilityColumn(),
			actionsColumn(onDeleteAlert, onEditAlert)]}
		legend={[
			{ icon: "percent", value: 'None', label: "Fake Legend" }
		]}
	/>
}